import { defineStore } from "pinia";

export const useGuestStore = defineStore("guest", {
  state: () => ({
    guest: {
      guest_id: 0,
      guest_user_id: 0,
      guest_ref: "",
    },
  }),
  actions: {
    setGuest(data) {
      this.guest = data;
    },
  },
});
